module.exports = __webpack_public_path__ + "img/12.323f06b6.png";